module.exports = __webpack_public_path__ + "static/media/CeraPro-Bold.db4c2aae.woff";